import Vue from "vue"
Vue.directive('tooltip', {
    inserted (el) {
        $gmx(document).ready(()=>{
          $(el).tooltip({
            animated: 'fade',
            placement: 'bottom',
            html: true
              });   
        });
        $(el).tooltip({
          animated: 'fade',
          placement: 'bottom',
          html: true
            }); 
    }
  });